export default {"src":"/_next/static/media/starbrust.6068e9dd.svg","height":37,"width":145,"blurWidth":0,"blurHeight":0};